import { useMemo } from 'react';
import type { TextSettings } from '../core/text/settings';
import { selectTextSettings, useStudio, type StudioState } from '../store/studioStore';

/**
 * Derives the typed `TextSettings` from the document.
 *
 * This must not be passed to `useStudio` directly: the selector builds a fresh object
 * on every call, so zustand's reference check would never settle and React would
 * re-render forever. Memoising on the document — a reference that only changes when
 * something is actually committed — gives a stable object instead.
 */
export function useTextSettings(): TextSettings {
  const doc = useStudio((s) => s.doc);
  return useMemo(() => selectTextSettings({ doc } as StudioState), [doc]);
}
